import { useAuthStore } from '@/stores/auth';

interface NuxtContext {
	route: import('vue-router').Route;
	redirect: (
		location:
			| string
			| {
					name?: string;
					path?: string;
					params?: Record<string, string>;
					query?: Record<string, string>;
			  },
	) => void;
	[key: string]: any;
}

/**
 * Nomi delle route che non richiedono autenticazione
 */
const PUBLIC_ROUTES = ['login___it', 'pr___it', 'pr/userId___it'] as const;

/**
 * Middleware di autenticazione che gestisce l'accesso alle route protette
 *
 * Logica:
 * - Se l'utente NON è autenticato e cerca di accedere a route protette → redirect al login
 * - Se l'utente È autenticato e cerca di accedere a route pubbliche → redirect alla dashboard
 *
 * @param context - Contesto Nuxt con route, redirect e store
 */
export default function auth(context: NuxtContext): void {
	const { route, redirect } = context;

	// Usa Pinia invece di Vuex
	const authStore = useAuthStore();

	const isPublicRoute = PUBLIC_ROUTES.includes(route.name as any);
	const isUserAuthenticated = authStore.isAuth;

	// Utente non autenticato che cerca di accedere a route protette
	if (!isPublicRoute && !isUserAuthenticated) {
		return redirect({ name: 'login___it' });
	}

	// Utente autenticato che cerca di accedere a route pubbliche
	if (isPublicRoute && isUserAuthenticated) {
		return redirect({ name: 'dashboard___it' });
	}
}
